import { TableSorting } from '@src/types'
import { ObjectWithStringKeysAndStringValue } from '@src/types/ObjectWithStringKeysAndStringValue'
import {
    PaymentAccount,
    PaymentAccountDetails,
} from '@src/types/PaymentAccount'
import { AxiosRequestConfig } from 'axios'
import { ApiRes, api } from './client'

export interface PaymentAccountsResponse {
    success: boolean
    payment_accounts_count: number
    payment_accounts: PaymentAccount[]
}

export interface PaymentAccountResponse {
    success: boolean
    payment_account: PaymentAccount
}

export const getPaymentAccounts = (
    filters?: ObjectWithStringKeysAndStringValue,
    page?: number,
    limit?: number,
    sorting?: TableSorting[]
): ApiRes<PaymentAccountsResponse> => {
    const config: AxiosRequestConfig = {}

    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    if (typeof page !== 'undefined' && typeof limit !== 'undefined') {
        config.params['range'] = page * limit - limit + '-' + page * limit
    } else {
        config.params['disable_pagination'] = true
    }

    if (sorting && sorting.length) {
        config.params['sort'] = sorting
            .map((sort) => {
                return (sort.direction === 'desc' ? '-' : '') + sort.field
            })
            .join(',')
    }

    return api.get('v2/manage/payment-accounts', config)
}

export const getPaymentAccount = (id: string): ApiRes<PaymentAccountDetails> =>
    api.get('v2/manage/payment-accounts/' + id)

export const updatePaymentAccount = (
    paymentAccount: PaymentAccountDetails
): ApiRes<PaymentAccountResponse> =>
    api.patch('v2/manage/payment-accounts/' + paymentAccount.id, paymentAccount)

export const createPaymentAccount = (
    paymentAccount: PaymentAccountDetails
): ApiRes<PaymentAccount> =>
    api.post('v2/manage/payment-accounts', paymentAccount)

export const deletePaymentAccount = (
    paymentAccount: PaymentAccount | PaymentAccountDetails
): ApiRes<PaymentAccountResponse> =>
    api.delete('v2/manage/payment-accounts/' + paymentAccount.id)

export const deletePaymentAccounts = (
    paymentAccounts: string[]
): ApiRes<PaymentAccountResponse> =>
    api.delete('v2/manage/payment-accounts', {
        data: { paymentAccounts: paymentAccounts },
    })
